import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './QuestionSkeleton.scss';

const QuestionSkeleton = () => {
  return (
    <div className="question-skeleton-container">
      {/* Header Section */}
      {/* <div className="header-section">
        <Skeleton height={40} width={200} />
      </div> */}

      {/* Main Sections */}
      {Array(2).fill().map((_, index) => (
        <div key={index} className="skeleton-section">
          {/* Section Title */}
          <div className="section-header">
            <Skeleton height={32} width={550} />
            <Skeleton height={32} width={80} className="edit-button" />
          </div>

          {/* Audit Prompts */}
          <div className="audit-prompts">
            <Skeleton height={24} width={150} className="prompt-header" />
            <div className="prompt-items">
              {Array(2).fill().map((_, i) => (
                <Skeleton key={i} height={20} className="prompt-item" />
              ))}
            </div>
            <Skeleton height={36} width={180} className="add-prompt-button" />
          </div>

          {/* Subsections */}
          <div className="subsections">
            {Array(2).fill().map((_, i) => (
              <div key={i} className="subsection">
                <Skeleton height={28} width={220} className="subsection-title" />
                <div className="question-items">
                  {Array(2).fill().map((_, j) => (
                    <div key={j} className="question-item">
                      <Skeleton height={24} className="question-text" />
                      <div className="question-actions">
                        <Skeleton width={100} height={24} className="required-checkbox" />
                        <div className="action-buttons">
                          <Skeleton width={80} height={32} className="action-button" />
                          <Skeleton width={80} height={32} className="action-button" />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <Skeleton height={36} width={160} className="add-question-button" />
              </div>
            ))}
            <Skeleton height={40} width={200} className="add-subsection-button" />
          </div>
        </div>
      ))}

      {/* Add New Section Button */}
      <div className="add-section-button">
        <Skeleton height={40} width={180} />
      </div>

      {/* Save Button */}
      <div className="save-button-container">
        <Skeleton height={45} width={120} className="save-button" />
      </div>
    </div>
  );
};

export default QuestionSkeleton;
